import { useEffect } from "react";
import { useNavigate } from "react-router";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { useLocale } from "../context/LanguageContext";

/**
 * Web SSO callback landing: backend sets `kommit_refresh` cookie and
 * redirects here; we exchange it for an access token and enter the app.
 */
export function OidcLandingPage() {
  const navigate = useNavigate();
  const { completeOidcWebSession } = useAuth();
  const { t } = useLocale();

  useEffect(() => {
    let cancelled = false;

    async function complete() {
      try {
        await completeOidcWebSession();
        if (!cancelled) {
          navigate("/", { replace: true });
        }
      } catch {
        if (!cancelled) {
          navigate("/login?error=sso_failed", { replace: true });
        }
      }
    }

    void complete();

    return () => {
      cancelled = true;
    };
  }, [completeOidcWebSession, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-4 text-center">
        <Loader2
          className="h-8 w-8 animate-spin text-primary"
          aria-hidden
        />
        <p className="text-sm text-muted-foreground">{t("oidc.landing.title")}</p>
      </div>
    </div>
  );
}
